<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* background-image: url("../assets/login-bg.png"); */
  /* background-size: cover; */
}
.logo {
  width: 100%;
}
.logo2 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logo_image {
  width: 175px;
  height: 54px;
  margin: 47px 0px 0px 53px;
}
.logo_image2 {
  width: 100px;
  height: 100px;
}
.logo-form {
  width: 408px;
  height: 800px;
  /* background-color: red; */
  margin: 0 auto;
  text-align: center;
}
.logo-form-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #3d3d3d;
  margin: 16px 0px 24px 0px;
}
::v-deep .el-input__inner {
  height: 54px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 40px;
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 16px;
}
.person_logo {
  width: 24px;
  height: 24px;
  margin: 16px 16px 0px 8px;
}
.verification_img {
  width: 127px;
  height: 46px;
  margin-top: 4px;
}
.df1 {
  display: flex;
  justify-content: end;
}
.mt16 {
  margin-top: 16px;
}
::v-deep .el-button {
  width: 100%;
  border-radius: 35px;
  background: #2e7516;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  margin-top: 18px;
}

.read {
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 16px 0px 34px 0px;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  margin: 0px 8px;
}
.login-line {
  display: flex;
}
.line1 {
  width: 161px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
}
.line2 {
  flex: 1;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  margin-top: -8px;
}
.dialog-footer-button {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  background: #ffffff;
  line-height: 5px;
  font-size: 14px;
}
.dialog-footer-button2 {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: #ffffff;
  background: #2e7516;
  line-height: 5px;
  font-size: 14px;
}

.header h1 {
  width: 100%;
  text-align: center;
  font-size: 24px;
}
.content {
  padding: 0px 20px 20px 20px;
}
.pt8 {
  padding-top: 8px;
}

.fw700 {
  font-weight: 700;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
ul {
  margin-left: 40px;
}
.p16 {
  padding: 16px 0px;
}
.ml22 {
  margin-left: 22px;
}
.ml28 {
  margin-left: 28px;
}
</style>
<template>
  <div class="app">
    <div class="header">
      <h1>XRION 付费服务协议</h1>
    </div>
    <div class="content">
      <p class="pt8 fw700">发布日期：2025年08月01日</p>
      <p class="pt8 fw700">生效日期：2025年08月01日</p>

      <div class="section-title">一、服务内容</div>
      <p class="ml22">1.服务类型</p>
      <ul>
        <li>文本即时翻译：支持在Web端直接输入文本进行翻译</li>
        <li>语音实时翻译：支持通过麦克风输入语音进行实时交互翻译</li>
        <li>API调用服务：通过Web API接口获取翻译服务</li>
      </ul>

      <div class="section-title">二、账户与订阅</div>
      <p class="ml22">1.账户注册</p>
      <ul>
        <li>支持邮箱/手机号注册Web端账户</li>
        <li>企业用户需提供营业执照复印件（PDF格式）</li>
      </ul>
      <p class="ml22">2.订阅方案以订阅界面实时内容为准。</p>

      <div class="section-title">三、支付与结算</div>
      <p class="ml22">1.支付方式</p>
      <ul>
        <li>信用卡支付：通过Stripe处理（Visa/Mastercard/Amex）</li>
        <li>支付宝：即时到账</li>
        <li>银行转账：仅限企业用户（3-5个工作日到账）</li>
      </ul>
      <p class="ml22">2.发票开具</p>
      <ul>
        <li>如需开具发票请在购买后联系客服：<a href="">admin@xrion.ai </a></li>
      </ul>

      <div class="section-title">四、服务使用规则</div>
      <p class="ml22">1.浏览器支持</p>
      <ul>
        <li>推荐使用Chrome 90+/Firefox 85+/Edge 90+</li>
        <li>不保证IE浏览器的兼容性</li>
      </ul>
      <p class="ml22">2.数据安全</p>
      <ul>
        <li>所有Web传输使用TLS 1.3加密</li>
        <li>用户输入的原文在翻译完成后立即从服务器删除</li>
      </ul>

      <div class="section-title">五、API服务条款</div>
      <p class="ml22">1.调用限制</p>
      <ul>
        <li>已购买套餐为准。</li>
      </ul>
      <p class="ml22">2.使用要求</p>
      <ul>
        <li>必须在User-Agent中包含"XRION-API"</li>
        <li>禁止伪造来源IP地址</li>
      </ul>

      <div class="section-title">六、退款政策</div>
      <p class="ml22">1.适用情况</p>
      <ul>
        <li>新用户7天内无理由退款</li>
      </ul>
      <p class="ml22">
        2.退款须联系客服处理，客服邮箱：<a href="">admin@xrion.ai</a>
      </p>

      <div class="section-title">七、服务终止</div>
      <p class="ml22">1.用户注销账户终止服务。</p>
      <p class="ml22">2.用户购买的套餐到期活使用完毕自动停止服务。</p>
      <p class="ml22">3.用户违反使用条款（如恶意爬取），XRION可终止服务。</p>

      <div class="section-title">八、技术支持</div>
      <p class="ml22">客服邮箱：<a href="">admin@xrion.ai</a></p>

      <p class="fw700 p16">重要提示：</p>
      <p class="fw700 ">1.请勿在公共电脑保存登录状态</p>
      <p class="fw700 ">2.定期修改账户密码</p>
      <p class="fw700 ">3.企业用户建议使用IP白名单功能</p>
      <p class="fw700 p16">
        本协议是《XRION用户协议》的补充条款，如有冲突以本协议为准。继续使用即表示您同意本协议所有条款。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaidServiceAgreement",
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>
